<template>
  <div class="Navigation">
    <b-list-group>
      <template v-for="step in navigationSteps">
        <b-list-group-item
          :key="step.key"
          :active="isCurrentStep(step)"
          :variant="stepVariant(step)"
          :disabled="!canNavigateAway"
          button
          @click="goTo(step)"
        >
          {{ step.label }}
        </b-list-group-item>
        <b-list-group-item
          v-for="subStep in step.steps"
          :key="subStep.key"
          :active="isCurrentStep(subStep)"
          class="substep"
          :variant="stepVariant(subStep)"
          :disabled="!canNavigateAway"
          button
          @click="goTo(subStep)"
        >
          {{ subStep.label }}
        </b-list-group-item>
      </template>
    </b-list-group>
  </div>
</template>

<style lang="scss" scoped>
.Navigation {
  display: none;

  @media (min-width: 576px) {
    display: block;
  }

  flex-basis: 200px;
  margin: 4px;

  .substep {
    padding-left: 2em;
  }
}
</style>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'Navigation',
  computed: {
    ...mapState(['currentStep', 'error']),
    ...mapGetters(['navigationSteps', 'canNavigateAway']),
  },
  methods: {
    isCurrentStep(step) {
      return step.key === this.currentStep;
    },
    stepVariant(step) {
      return step.error || (this.isCurrentStep(step) && this.error) ? 'danger' : null;
    },
    goTo(step) {
      this.$eventHub.$emit('navigate-attempt', step.key);
    },
  },
};
</script>
